/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import { BasicButton } from '@adsk/alloy-react-button';
import { XIcon } from '@adsk/alloy-react-icon';
import Divider from '@adsk/alloy-react-divider';
import {
  dividerStyles,
  flexContainer,
  leftContainerStyle,
  mainContainerStyles,
} from './styles';

const MemberFilterPanelHeader = ({ title, onClose }) => {
  return (
    <div css={mainContainerStyles}>
      <div css={flexContainer}>
        <div css={leftContainerStyle}>{title}</div>
        <BasicButton
          data-testid="MemberFilterPanel_CloseButton"
          onClick={onClose}
        >
          <XIcon />
        </BasicButton>
      </div>
      <Divider style={dividerStyles} />
    </div>
  );
};

MemberFilterPanelHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default MemberFilterPanelHeader;
